import { ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { sectionTrail } from '../../../shared/components/section-trail';
import { useCustomerFilterOptions } from '../../jobs/features/list/public/use-customer-filter-options';
import { buildDeadlinesColumns } from '../components/build-deadlines-columns';
import { DeadlinesTable } from '../components/DeadlinesTable';
import { MarkReturnedModal } from '../components/MarkReturnedModal';
import { useDeadlinesBoard } from '../hooks/use-deadlines-board';
import { useLevelFilterOptions } from '../hooks/use-deadline-filter-options';
import { useMarkReturned } from '../hooks/use-mark-returned';

/** Containers still owing their empty back, soonest deadline first (gitaumoses4/chukua#38). */
export function DeadlinesBoardPage() {
  const { state, list, isRefreshing, reload } = useDeadlinesBoard();
  const customerOptions = useCustomerFilterOptions().map((option) => ({ text: option.label, value: option.value }));
  const levelOptions = useLevelFilterOptions();
  const markReturned = useMarkReturned(reload);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildDeadlinesColumns({ list, customerOptions, levelOptions, onMarkReturned: markReturned.open });

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('deadlines')}
        title="Deadlines"
        description="Containers with an empty still to return, by days remaining to the free-days deadline."
      />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load the deadlines" description="Something went wrong loading this list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading deadlines" withSearch />}
      {state.status === 'loaded' && <DeadlinesTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <MarkReturnedModal
        target={markReturned.target}
        error={markReturned.error}
        submitting={markReturned.submitting}
        onSubmit={markReturned.submit}
        onCancel={markReturned.close}
      />
    </>
  );
}
